import { useEffect, useState } from 'react';
import { AnyInput } from './AnyInput';
import { ValueWrapperObject } from './ValueWrapper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

export type ObjectInputProps<T extends Record<string, unknown>> = {
  input: ValueWrapperObject<T>;
  onChange: (value: T) => void;
  object: T;
};

export const ObjectInput = <T extends Record<string, unknown>>({
  input,
  onChange,
  object,
}: ObjectInputProps<T>): JSX.Element => {
  const { title, fields } = input;
  const [output, setOutput] = useState<T>(object);
  useEffect(() => {
    onChange(output);
  }, [onChange, output]);

  const keys = Object.keys(fields) as (keyof T)[];

  return (
    <Stack spacing={2} sx={{ display: 'flex', flexDirection: 'column', mb: 4 }}>
      <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
        {title}:
      </Typography>
      <Stack spacing={3}>
        {keys.map((key) => {
          const inputField = fields[String(key)];
          const objectField = object[String(key)];
          return (
            <Stack key={String(key)} sx={{ mb: 3 }}>
              <AnyInput
                input={inputField}
                onChange={(value) => {
                  // eslint-disable-next-line security/detect-object-injection
                  if (output[key] === value) {
                    return;
                  }
                  setOutput((prev) => ({ ...prev, [key]: value }));
                }}
                object={objectField}
              />
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
